<template>
  <footer :class="$style.container">
    <v-container
      :class="$style.gridGap"
      d-flex
      align-center
      flex-md-row
      flex-column
      justify-space-between
    >
      <ul :class="$style.list" class="justify-center justify-md-start">
        <li v-for="rel in allNavigationItems" :key="rel.id" :class="$style.listitem">
          <NavigationElement :key="rel.id" v-bind="rel" />
        </li>
      </ul>
      <Copyright :class="$style.copyright" class="mt-md-0" />
      <!-- <HubSpotChat /> -->
    </v-container>
  </footer>
</template>

<script>
import API_CONSTANTS from '@/js/helper/api-constants.js'
import { parseDataAttributeJson } from '@/js/helper/data-attribute-helper.js'
import { getAllNavigationItems } from '@/js/helper/navigation-helper.js'

import NavigationElement from '@/js/components/Navigation/NavigationElement.vue'
import Copyright from '@/js/components/Shared/Copyright.vue'
// import HubSpotChat from '@/js/components/Chat/HubSpotChat.vue'

export default {
  name: 'FooterNavigation',
  components: { NavigationElement, Copyright }, //HubSpotChat
  props: {
    element: {
      type: String,
      default: '',
    },
  },
  data() {
    return parseDataAttributeJson(this.element)
  },
  computed: {
    allNavigationItems() {
      const filterCallback = key =>
        key === API_CONSTANTS.ELEMENTS || key === API_CONSTANTS.NAVIGATION.ITEM_TYPE

      return getAllNavigationItems(this.relationships, filterCallback)
    },
  },
}
</script>

<style lang="scss" module>
.container {
  border-top: 1px solid var(--black);
}

.gridGap {
  grid-gap: 0 1rem;
}

:global(.v-application) .list {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    display: flex;
    flex-wrap: wrap;
  }

  @media print {
    display: none !important;
  }

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  margin: 0 -1rem;
  padding: 0;
}

.listitem {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    margin: 0.5rem 1rem !important;

    font-size: var(--font-base);
    text-align: left;
  }
  margin: 0.25rem 0.3rem !important;
  padding: 0;

  font-size: var(--font-sm);
  word-break: break-word;
}

.copyright {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    margin-top: 1rem !important;

    font-size: var(--font-base);
  }
  margin-top: 0.25rem !important;

  color: var(--grey);
  font-size: var(--font-sm);
  white-space: nowrap;
}
</style>
